import '@/modules/global';
import { Header, StickyHeader } from '@/modules/header';
import PredictiveSearch from '@/modules/predictive-search';
import CartNotification from '@/modules/cart-notification';
import ResponsiveVideo from '@/modules/responsive-video';
import LazyVideo from '@/modules/lazy-video';
import FeaturedCollectionsSlider from '@/modules/featured-collections'
import MediaGridSlider from '@/modules/media-grid'
import PortraitVideoSwiper from '@/modules/portrait-video-swiper';
import ProductCarousel from '@/modules/product-carousel'
import ProductCategoryCarousel from '@/modules/product-category-carousel';
import NewsCarousel from '@/modules/news-carousel'
import HalfWidthCarousel from '@/modules/half-width-carousel'
import MediaCarousel from '@/modules/media-carousel'
import LogoGrid from '@/modules/logo-grid'
import FeaturedIconCarousel from '@/modules/featured-icon-carousel';
import AnnouncementCarousel from '@/modules/announcement-carousel';
import TabbedMediaContent from '@/modules/tabbed-media-content';

import '@/modules/accordion';
import KeyboardFocus from '@/modules/keyboard-focus/keyboard-focus';

const responsiveVideos = document.querySelectorAll('.js-responsive-video');
if (responsiveVideos) {
    Array.from(responsiveVideos).forEach(el => new ResponsiveVideo(el));
}

const lazyVideos = document.querySelectorAll('.js-lazy-video');
if (lazyVideos) {
    new LazyVideo(lazyVideos);
}

new Header();

if (document.getElementsByTagName('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
}

if (document.getElementsByTagName('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}

if (document.getElementsByTagName('cart-notification')) {
    customElements.define('cart-notification', CartNotification);
}

const collectionSliders = document.querySelectorAll('.js-featured-collections-slider');
if (collectionSliders) {
    collectionSliders.forEach(el => new FeaturedCollectionsSlider(el));
}

const mediaGridSliders = document.querySelectorAll('.js-media-grid-slider');
if (mediaGridSliders) {
    mediaGridSliders.forEach(el => new MediaGridSlider(el));
}

const productSliders = document.querySelectorAll('.js-product-carousel');
if (productSliders) {
    productSliders.forEach(el => new ProductCarousel(el));
}

const portraitVideoSwiper = document.querySelectorAll('.js-portrait-video-carousel');
if (portraitVideoSwiper) {
    portraitVideoSwiper.forEach(el => new PortraitVideoSwiper(el));
}

const productCategorySliders = document.querySelectorAll('.js-product-category-carousel');
if (productCategorySliders) {
    productCategorySliders.forEach(el => new ProductCategoryCarousel(el));
}

const newsSliders = document.querySelectorAll('.js-news-carousel');
if (newsSliders) {
    newsSliders.forEach(el => new NewsCarousel(el));
}

const halfWidthCarousel = document.querySelectorAll('.js-half-width-carousel');
if (halfWidthCarousel) {
    halfWidthCarousel.forEach(el => new HalfWidthCarousel(el));
}

const mediaCarousel = document.querySelectorAll('.js-media-carousel');
if (mediaCarousel) {
    mediaCarousel.forEach(el => new MediaCarousel(el));
}

const logoGrid = document.querySelectorAll('.js-logo-grid');
if (logoGrid) {
    logoGrid.forEach(el => new LogoGrid(el));
}

const featuredIconsSliders = document.querySelectorAll('.js-featured-icons-carousel');
if (featuredIconsSliders) {
    featuredIconsSliders.forEach(el => new FeaturedIconCarousel(el));
}

const announcementCarousels = document.querySelectorAll('.js-announcement-carousel');
if (announcementCarousels) {
    announcementCarousels.forEach(el => new AnnouncementCarousel(el));
}

const tabbedContentCarousels = document.querySelectorAll('.js-tabbed-media-content');
if (tabbedContentCarousels) {
    tabbedContentCarousels.forEach(el => new TabbedMediaContent(el));
}

new KeyboardFocus();
